import { render, staticRenderFns } from "./UserCompanyPage.vue?vue&type=template&id=581770d8&"
import script from "./UserCompanyPage.vue?vue&type=script&lang=js&"
export * from "./UserCompanyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('581770d8')) {
      api.createRecord('581770d8', component.options)
    } else {
      api.reload('581770d8', component.options)
    }
    module.hot.accept("./UserCompanyPage.vue?vue&type=template&id=581770d8&", function () {
      api.rerender('581770d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/administration/UserCompanyPage.vue"
export default component.exports